import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify"
import axios from "axios";

export function TaskParentDeletionModal(props) {

    const [task, setTask] = useState({});
    useEffect(() => {
        setTask(props.task);
    }, [props.task]);

    const deleteData = () => {
        let body = {
            parent_id: null
        };
        axios.post(process.env.REACT_APP_API_URL + '/api/tasks/' + task.id + '/updateParent', body).then((d) => {
            toast.success("Eltern Task Verknüpfung entfernt");
            props.onSubmit();
        }).catch(e => {
            toast.error("Es ist ein Fehler aufgetreten oder du bist für diese Aktion nicht berechtigt. Versuche es erneut oder wende dich an einen Administrator.",{autoClose: 5500});
            props.onSubmit();
        });
    }

    return <>
        <Modal
            show={props.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.onHide}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Eltern Task Verknüpfung entfernen
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Bist du dir sicher dass du diesen Eltern Task Verknüpfung entfernen möchtest?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={deleteData}>Ja, Eltern Task Verknüpfung entfernen</Button>
                <Button variant="default " onClick={props.onHide}>Nein, Eltern Task Verknüpfung nicht entfernen</Button>
            </Modal.Footer>

        </Modal>
    </>
}
